import React from 'react';
import triplei from '../../Assets/Triplei.png'
import './TripleI.css';

const TripleI = () => {
    return (
        <>
            <div style={{ padding: "50px" }}>
                <img src={triplei} className='responsive' alt="Triple i Approach" />
            </div>


        </>
    );
}

export default TripleI;